import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { Button, CircularProgress, Pagination } from "@mui/material";
import { withCustomerAuth } from "../../../admin/components/GetAuth";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import { fetchOrders, formatPrice, ORDER_PROGRESS_COLOR } from "../../../frontend/pages/shop/shopApi";
import styles from "../../../frontend/pages/shop/shop.module.css";
import CustomerShell from "./CustomerShell";

// Shop Now orders of the signed-in customer
const OrderHistory = () => {
  const { websiteData } = useWebsite();
  useSiteBranding("Order history", websiteData);
  const [orders, setOrders] = useState(null);
  const [meta, setMeta] = useState({ current_page: 1, last_page: 1, total: 0 });
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchOrders({ page, per_page: 15 }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setOrders(response.data.data || []);
        setMeta(response.data.meta || {});
      } else {
        setOrders([]);
      }
    }).catch(() => setOrders([]));
  }, [page]);

  return (<CustomerShell eyebrow="Shop Now" title="Order history" sub={orders ? `${meta.total || 0} order${meta.total === 1 ? "" : "s"}` : ""} actions={<Button component={Link} to="/customer/shop" className={styles.SecondaryBU}>Shop Now</Button>}>
    <div className={styles.Embedded}>
      {!orders && <div className={styles.Empty}><CircularProgress size={28} /></div>}

      {orders && orders.length === 0 && (<div className={`${styles.Panel} ${styles.Empty}`}>
        <p>You have not placed any orders yet.</p>
        <Button component={Link} to="/customer/shop" className={styles.PrimaryBU} style={{ marginTop: 12 }}>Start shopping</Button>
      </div>)}

      {orders && orders.length > 0 && (<div className={styles.Panel}>
        {orders.map((order) => (<Link to={`/customer/order-history/${order.id}`} className={styles.OrderRow} key={order.id}>
          <div>
            <strong>#{order.order_no}</strong>
            <div className={styles.LineMeta}>{dayjs(order.created_at).format("DD MMM YYYY")} · {order.items_count} item{order.items_count === 1 ? "" : "s"}</div>
          </div>
          <div className={styles.LineMeta}>Delivery {order.delivery_date ? dayjs(order.delivery_date).format("DD MMM YYYY") : "-"}</div>
          <strong>{formatPrice(order.total)}</strong>
          <span className={styles.StatusPill} style={{ background: ORDER_PROGRESS_COLOR[order.progress] || "#64748b" }}>{order.progress}</span>
        </Link>))}
      </div>)}

      {meta.last_page > 1 && (<div className={styles.Pager}>
        <Pagination count={meta.last_page} page={meta.current_page} onChange={(e, p) => setPage(p)} />
      </div>)}
    </div>
  </CustomerShell>);
};

export default withCustomerAuth(OrderHistory);
